var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"clearable":"","outlined":"","return-object":"","hide-details":"","item-text":"nombre","items":_vm.items,"label":"Categoria","dense":""},model:{value:(_vm.categoria),callback:function ($$v) {_vm.categoria=$$v},expression:"categoria"}})
}
var staticRenderFns = []

export { render, staticRenderFns }